<template>
    <div>
        <form-wrapper :validator="$v.model" class="form-wrapper">
            <form-group label="Account Code" name="accountCode">
                <md-input v-model.trim="model.accountCode" />
            </form-group>
            <form-group label="Username" name="username">
                <md-input v-model.trim="model.username" />
            </form-group>
            <form-group label="Password" name="password">
                <md-input v-model.trim="model.password" />
            </form-group>
        </form-wrapper>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'TgeKeys',
    props: {
        data: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            model: {
                accountCode: '',
                username: '',
                password: ''
            }
        };
    },
    validations() {
        return {
            model: {
                accountCode: { required },
                username: { required },
                password: { required }
            }
        };
    },
    methods: {
        update() {
            this.$v.model.$touch();
            if (this.$v.model.$invalid) 
                return;

            this.$emit('onUpdate', { tgeAccess: { ...this.model } });
        }
    },
    watch: {
        data(value) {
            Object.assign(this.model, value);
        }
    }
};
</script>
